<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="agpm.task_history.title"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
  </div>
</div>
